import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

import getPlanLabel from 'modules/billing/lib/getPlanLabel'
import plans from 'modules/billing/store/collections/plans'

import { LegacyPlan } from './LegacyPlan'
import { ModernPlan } from './ModernPlan'

interface Props {
  onCTAClick: () => void | Promise<void>
}

export const YourRecruitmentPlan = ({ onCTAClick }: Props) => {
  const { featureAvailability } = useFeatureAvailability(Features.ats_active_jobs)

  const usage = featureAvailability?.usage ?? 0
  const usageLimit = featureAvailability?.usageLimit ?? 0

  const atsPlan = plans.currentAts
  const planType = atsPlan ? atsPlan.type : 'none'
  const planLabel = getPlanLabel(planType)
  const factorialChargeBee = hasFeature('dev_chargebee')

  // This is not really intention revealing, but we are not showing this component
  // for legacy plans because all the legacy plans have ats included for free so
  // we don't need to show the ats plan component
  if (plans.current.isLegacy && !factorialChargeBee) return null

  return (
    <>
      {!factorialChargeBee && <LegacyPlan onCTAClick={onCTAClick} planLabel={planLabel} />}
      {factorialChargeBee && <ModernPlan usageLimit={usageLimit} usage={usage} />}
    </>
  )
}
